module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-13-0ee0c0bfcedf337c76c0992bb8e0dd82.png";